import { render } from "./LegacyBillingView.vue?vue&type=template&id=580e9127"
import script from "./LegacyBillingView.vue?vue&type=script&lang=js"
export * from "./LegacyBillingView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__